export default __webpack_public_path__ + "static/media/tetrapak.777e4441.png";